(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('uzb-card', {
            parent: 'entity',
            url: '/uzb-card?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.uzbCard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/uzb-card/uzb-cards.html',
                    controller: 'UzbCardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                userPhone: null,
                owner: null,
                cardNumber: null,
                phone: null,
                blocked: -1
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        userPhone: $stateParams.userPhone,
                        owner: $stateParams.owner,
                        cardNumber: $stateParams.cardNumber,
                        phone: $stateParams.phone,
                        blocked: $stateParams.blocked
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('uzbCard');
                    $translatePartialLoader.addPart('tkbCard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('uzb-card-detail', {
            parent: 'uzb-card',
            url: '/uzb-card/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.uzbCard.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/uzb-card/uzb-card-detail.html',
                    controller: 'UzbCardDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('uzbCard');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UzbCard', function($stateParams, UzbCard) {
                    return UzbCard.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'uzb-card',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('uzb-card-detail.edit', {
            parent: 'uzb-card-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uzb-card/uzb-card-dialog.html',
                    controller: 'UzbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UzbCard', function(UzbCard) {
                            return UzbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('uzb-card.new', {
            parent: 'uzb-card',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uzb-card/uzb-card-dialog.html',
                    controller: 'UzbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                owner: null,
                                number: null,
                                id: null
                            };
                        },
                        isEdit: function() {
                            return false;
                        }
                    }
                }).result.then(function() {
                    $state.go('uzb-card', null, { reload: 'uzb-card' });
                }, function() {
                    $state.go('uzb-card');
                });
            }]
        })
        .state('uzb-card.edit', {
            parent: 'uzb-card',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uzb-card/uzb-card-dialog.html',
                    controller: 'UzbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UzbCard', function(UzbCard) {
                            return UzbCard.get({id : $stateParams.id}).$promise;
                        }],
                        isEdit: [function () { return true; }]
                    }
                }).result.then(function() {
                    $state.go('uzb-card', null, { reload: 'uzb-card' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('uzb-card.delete', {
            parent: 'uzb-card',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uzb-card/uzb-card-delete-dialog.html',
                    controller: 'UzbCardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UzbCard', function(UzbCard) {
                            return UzbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('uzb-card', null, { reload: 'uzb-card' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
